import dayjs from "dayjs";

import { z } from "zod";

/**
 * Custom transformations
 */

const hoursToMinutes = (x: string | null): number => {
  try {
    if (x === null) return 0;
    const arr = x.split(':');
    const hours = parseInt(arr[0]);
    const minutes = parseInt(arr[1]);
    if (isNaN(hours) || isNaN(minutes)) return 0;
    return dayjs.duration({ hours, minutes }).asMinutes();
  } catch (_: unknown) {
    return 0;
  }
}

/**
 * TreinamentoSchema
 */

export const TreinamentoSchema = z.object({
  idTreinamento: z.coerce.number(),
  cargaHoraria: z.string().transform(x => hoursToMinutes(x)),
  local: z.string(),
  instrutor: z.string(),
  dataRealização: z.coerce.date(),
  prazoAvaliacao: z.coerce.number(),
});

/**
 * TreinamentoForm
 */

export type TreinamentoForm = z.infer<typeof TreinamentoSchema>;